<template>
<div>
  <!-- Application Bar -->
  <mu-appbar title="" class="syn-appbar">
    <mu-flat-button icon="menu" label="Menu" color="white" slot="left" class="white" @click="toggle(true)"></mu-flat-button>
    <mu-flat-button @click="toggleUsr" ref="button" :label="$auth.user.usr_lastname + ' ' + $auth.user.usr_firstname" slot="right" icon="person"></mu-flat-button>
    <mu-popover :trigger="trigger" :open="openUsr" @close="handleClose">
      <mu-menu>
        <mu-menu-item href="#/pref" @click="saveRoute()" title="Paramètres" leftIcon="settings"></mu-menu-item>
        <mu-menu-item @click="logout()" title="Se déconnecter" leftIcon="power_settings_new" leftIconColor="red"></mu-menu-item>
      </mu-menu>
    </mu-popover>
  </mu-appbar>
  <!--    MENU Gauche     -->
  <mu-drawer :open="open" :docked="docked" @close="toggle(true)">
    <mu-appbar>
      <img src="../assets/logo_small.svg" alt="logo" style="height: 44px; vertical-align: bottom; margin-bottom: 11px;" />
      &nbsp; Menu
    </mu-appbar>
    <mu-menu :autoWidth="false" @itemClick="toggle(true)">
      <mu-menu-item href="#/dashboard" title="Tableau de bord" leftIcon="home"></mu-menu-item>
      <mu-menu-item href="#/scan" title="Scanner" leftIcon="cast"></mu-menu-item>
      <mu-divider></mu-divider>
      <mu-sub-header>Administratif</mu-sub-header>
      <mu-menu-item href="#/vouch" title="Récépissés" leftIcon="receipt"></mu-menu-item>
      <mu-menu-item href="#/declaration" title="Déclaration" leftIcon="send"></mu-menu-item>
      <!-- <mu-menu-item href="#/invoice" title="Factures" leftIcon="description"></mu-menu-item> -->
      <mu-menu-item href="#/report" title="Rapports" leftIcon="show_chart"></mu-menu-item>
      <mu-menu-item href="#/map" title="Carte" leftIcon="map"></mu-menu-item>
      <!-- <mu-menu-item href="#/docrecep" title="Documents" leftIcon="attach_file"></mu-menu-item> -->
      <mu-divider></mu-divider>
      <mu-sub-header>Paramétrage</mu-sub-header>
      <mu-menu-item href="#/driver" title="Chauffeurs" leftIcon="account_circle"></mu-menu-item>
      <mu-menu-item href="#/address" title="Gestion adresse" leftIcon="add_location"></mu-menu-item>
      <!-- <mu-menu-item href="#/report" title="Zone chauffeur" leftIcon="select_all"></mu-menu-item> -->
      <mu-divider></mu-divider>
      <mu-menu-item v-if="user.role=='admin'" href="#/addressmanage" title="Traitement adresse" leftIconColor="#f44336" leftIcon="build"></mu-menu-item>
      <!-- <mu-menu-item href="#/user" title="Utilisateurs" leftIcon="person"/> -->
    </mu-menu>   
  </mu-drawer>
</div>
</template>

<script>
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import appBar     from 'muse-components/appBar'
import flatButton from 'muse-components/flatButton'
import drawer     from 'muse-components/drawer'
import {menu}     from 'muse-components/menu'
import {menuItem} from 'muse-components/menu'
import popover    from 'muse-components/popover'
import divider    from 'muse-components/divider'
import subHeader    from 'muse-components/subHeader'

export default {
  data: function () {
    return {
      open: false,
      docked: false,
      openUsr: false,
      trigger: null,
      user: ns.sessionStorage.get( APP_COD + "_token" )
    }
  },
  mounted () {
    this.trigger = this.$refs.button.$el
  },
  methods: {
    toggle (flag) {
      this.open = !this.open
      this.docked = !flag
    },
    logout (){
      this.$auth.logout()
    },
    toggleUsr () {
      this.openUsr = !this.openUsr
    },
    handleClose (e) {
      this.openUsr = false
    },
    saveRoute(){
      this.$auth.routeBefore = this.$router.history.current.fullPath
      this.toggleUsr()
    }
  },
  components: {
      'mu-icon-button': iconButton,
      'mu-appbar': appBar,
      'mu-flat-button': flatButton,
      'mu-drawer': drawer,
      'mu-menu': menu, 'mu-menu-item': menuItem,
      'mu-popover': popover,
      'mu-divider' : divider,
      'mu-sub-header' : subHeader
  }
}
</script>

<style lang="less">
.syn-appbar{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
}
.mu-drawer a{
    text-decoration: none;

}

</style>


// WEBPACK FOOTER //
// Headbar.vue?8ec92612